import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const HERO_BACKGROUND = '1846d0d3af02770632d59daed108a892.png'

const HeroBanner = () => (
  <section
    className="h-[320px] w-full bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preFixImgUrl(HERO_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col justify-center text-white">
      <LangText
        lngKey="vip.hero.title"
        className="font-smiley-sans text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="vip.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white/80"
      />
    </div>
  </section>
)

export default HeroBanner
